import { create } from 'zustand';

export type PopupType = 'success' | 'fail' | 'info';

interface PopupState {
  isOpen: boolean;
  type: PopupType;
  title: string;
  score: number | string | null;
  message: string;
  onRestart: () => void;
  onHome: () => void;
  
  showPopup: (params: Omit<PopupState, 'isOpen' | 'showPopup' | 'closePopup'>) => void;
  closePopup: () => void;
}

export const usePopupStore = create<PopupState>((set) => ({
  isOpen: false,
  type: 'success',
  title: '',
  score: null,
  message: '',
  onRestart: () => {},
  onHome: () => {},

  showPopup: (params) => set({ ...params, isOpen: true }),
  closePopup: () => set({ isOpen: false })
}));
